import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssistedBrowsingPanelComponent } from './assisted-browsing-panel.component';
import { AssistedBrowsingFrameComponent } from './assisted-browsing-frame';
import { NavigationBarModule } from './navigation-bar/navigation-bar.module';
import { AssistedBrowsingService } from './assisted-browsing.service';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { WaitingForPermissionSplashScreenComponent } from './splash-screens/waiting-for-permission-splash-screen.component';
import { ConnectingSplashScreenComponent } from './splash-screens/connecting-splash-screen.component';
import { NoVisitorMonitorSplashScreenComponent } from './splash-screens/no-visitor-monitor-splash-screen.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    NavigationBarModule,
    SvgIconModule
  ],
  providers: [
    AssistedBrowsingService
  ],
  declarations: [
    AssistedBrowsingPanelComponent,
    AssistedBrowsingFrameComponent,
    ConnectingSplashScreenComponent,
    NoVisitorMonitorSplashScreenComponent,
    WaitingForPermissionSplashScreenComponent
  ],
  exports: [
    AssistedBrowsingPanelComponent,
    AssistedBrowsingFrameComponent
  ]
})
export class AssistedBrowsingModule {}
